/**
 * Newsletter form handler with JSONP submission to Mailchimp
 */

export function init() {
  const forms = document.querySelectorAll("[data-newsletter-form]");

  forms.forEach((form) => {
    form.addEventListener("submit", handleSubmit);
  });
}

/**
 * Subscribe an email to Mailchimp via JSONP.
 * @param {string} email - Email address to subscribe
 * @param {string} mailchimpUrl - Mailchimp subscribe/post URL (will be converted to post-json)
 * @returns {Promise<void>}
 */
export function subscribeToMailchimp(email, mailchimpUrl) {
  const jsonpBaseUrl = mailchimpUrl.replace(
    "subscribe/post",
    "subscribe/post-json",
  );

  const params = new URLSearchParams();
  params.append("EMAIL", email);
  params.append("tags", "3414315");
  params.append("gdpr[66963]", "Y");

  const callbackName = `mailchimp_callback_${Date.now()}`;
  const url = `${jsonpBaseUrl}&c=${callbackName}&${params.toString()}`;

  return new Promise((resolve, reject) => {
    window[callbackName] = function (response) {
      delete window[callbackName];
      const scriptEl = document.getElementById(callbackName);
      if (scriptEl) {
        scriptEl.remove();
      }

      if (response.result === "success") {
        if (typeof window.gtag === "function") {
          window.gtag("event", "sign_up", {
            method: "newsletter",
            form_destination: location.pathname,
          });
        }
        resolve();
      } else {
        let errorMsg = response.msg || "Subscription failed";
        errorMsg = errorMsg.replace(/<[^>]*>/g, "").replace(/^\d+\s*-\s*/, "");
        reject(new Error(errorMsg));
      }
    };

    const script = document.createElement("script");
    script.id = callbackName;
    script.src = url;
    script.onerror = function () {
      delete window[callbackName];
      script.remove();
      reject(new Error("Network error"));
    };

    document.body.appendChild(script);
  });
}

function handleSubmit(e) {
  e.preventDefault();

  const form = e.target;
  const button = form.querySelector(".newsletter__button");
  const messageContainer = form.querySelector("[data-newsletter-message]");
  const successEl = form.querySelector("[data-newsletter-success]");
  const errorEl = form.querySelector("[data-newsletter-error]");
  const formGroup = form.querySelector(".newsletter__form-group");
  const gdprGroup = form.querySelector(".newsletter__gdpr");

  // Disable button and show loading state
  const originalText = button.textContent;
  button.disabled = true;
  button.textContent = "...";

  // Hide previous messages
  messageContainer.hidden = true;
  successEl.hidden = true;
  errorEl.hidden = true;

  // Build the URL with form data
  const formData = new FormData(form);
  const params = new URLSearchParams();

  for (const [key, value] of formData.entries()) {
    params.append(key, value);
  }

  const url = `${form.action}&${params.toString()}`;

  // Create unique callback name
  const callbackName = `mailchimp_callback_${Date.now()}`;

  // Create JSONP callback
  window[callbackName] = function (response) {
    // Clean up
    delete window[callbackName];
    const script = document.getElementById(callbackName);
    if (script) {
      script.remove();
    }

    // Re-enable button
    button.disabled = false;
    button.textContent = originalText;

    // Show message container
    messageContainer.hidden = false;

    if (response.result === "success") {
      // Hide form fields, show success
      formGroup.style.display = "none";
      gdprGroup.style.display = "none";
      successEl.hidden = false;
      errorEl.hidden = true;

      // Track GA4 newsletter signup
      if (typeof window.gtag === "function") {
        window.gtag("event", "sign_up", {
          method: "newsletter",
          form_destination: location.pathname,
        });
      }
    } else {
      // Show error message
      successEl.hidden = true;
      errorEl.hidden = false;
      // Clean up Mailchimp error message (remove HTML and "0 -" prefix)
      let errorMsg = response.msg || "Ein Fehler ist aufgetreten.";
      errorMsg = errorMsg.replace(/<[^>]*>/g, "").replace(/^\d+\s*-\s*/, "");
      errorEl.textContent = errorMsg;
    }
  };

  // Replace callback placeholder in URL
  const jsonpUrl = url.replace("c=callback", `c=${callbackName}`);

  // Create and inject script tag for JSONP
  const script = document.createElement("script");
  script.id = callbackName;
  script.src = jsonpUrl;
  script.onerror = function () {
    delete window[callbackName];
    script.remove();
    button.disabled = false;
    button.textContent = originalText;
    messageContainer.hidden = false;
    successEl.hidden = true;
    errorEl.hidden = false;
    errorEl.textContent = "Verbindungsfehler. Bitte versuche es erneut.";
  };

  document.body.appendChild(script);
}
